<template>
  <div :class="['loginInput', { ativo: foco }]">
    <i :class="icon"></i>
    <input
      :type="type"
      :placeholder="placeholder"
      v-model="valor"
      @keyup="atualizarInput"
      @focus="focar"
      @blur="desfocar"
      @keydown.enter="entrar"
      :ref="referencia"
    />
  </div>
</template>

<style scoped lang="scss">
.loginInput input {
  height: 40px;
  border-radius: 10px;
  border: 1px solid #aaa;
  text-align: left;
  padding: 10px;
  max-width: 300px;
  border-left: 0;
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}

.loginInput i {
  display: flex;
  align-items: center;
  height: 40px;
  border: 1px solid #aaa;
  border-radius: 10px;
  border-bottom-right-radius: 0;
  border-top-right-radius: 0;
  border-right: 0;
  padding-left: 5px;
}

.ativo {
  input {
    border: 1px solid #ac08f0 !important;
    border-left: 0 !important;
  }
  i {
    border: 1px solid #ac08f0 !important;
    border-right: 0 !important;
  }
}
</style>

<script>
export default {
  name: "login-input",
  data() {
    return {
      valor: "",
      foco: false
    };
  },
  props: {
    icon: {
      type: String,
      description: "Input left icon",
    },
    type: {
      type: String,
      description: "Input type",
    },
    placeholder: {
      type: String,
      description: "Input placeholder",
    },
    focus:{
      type: Boolean,
      description: "Input focus",
    },
    referencia:{
      type: String,
      description: "Input ref"
    }
  },
  methods: {
    verificaUsuario() {
      this.valor = localStorage.getItem("senhaDigitada");
      return true;
    },
    atualizarInput() {
      this.$emit("atualizar-input", { recebido: this.valor });
    },
    entrar(){
        this.$emit("entrar")
    },
    focar() {
        this.foco = true;
    },
    desfocar() {
        this.foco = false
    },
  },
  mounted(){
    this.verificaUsuario();
  }
};
</script>
